import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./auth";
import { I18nProvider } from "./i18n";
import { ThemeProvider } from "./theme";
import Navbar from "./components/Navbar";
import WhatsAppFab from "./components/WhatsAppFab";
import ProtectedRoute from "./components/ProtectedRoute";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Matches from "./pages/Matches";
import Leaderboard from "./pages/Leaderboard";
import Prizes from "./pages/Prizes";
import Logs from "./pages/Logs";
import Admin from "./pages/Admin";
import "./App.css";

export default function App() {
  return (
    <ThemeProvider>
      <I18nProvider>
        <AuthProvider>
          <BrowserRouter>
            <div className="App min-h-screen text-white grain">
              <Navbar />
              <main className="relative z-10">
                <Routes>
                  <Route path="/" element={<Landing />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/register" element={<Register />} />
                  <Route path="/matches" element={<Matches />} />
                  <Route path="/leaderboard" element={<Leaderboard />} />
                  <Route path="/prizes" element={<Prizes />} />
                  <Route
                    path="/logs"
                    element={
                      <ProtectedRoute>
                        <Logs />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/admin"
                    element={
                      <ProtectedRoute adminOnly>
                        <Admin />
                      </ProtectedRoute>
                    }
                  />
                </Routes>
              </main>
              <Toaster
                theme="dark"
                position="top-right"
                toastOptions={{
                  style: {
                    background: "var(--toast-bg, #141414)",
                    border: "1px solid rgba(255,255,255,0.1)",
                    color: "var(--toast-fg, #fff)",
                  },
                }}
              />
              <WhatsAppFab />
            </div>
          </BrowserRouter>
        </AuthProvider>
      </I18nProvider>
    </ThemeProvider>
  );
}
